/**
 * Mapping of Stripe card brand identifiers to display names.
 * Covers all major card networks supported by Stripe.
 * @see https://stripe.com/docs/api/cards/object#card_object-brand
 */
const CARD_BRAND_DISPLAY_NAMES: Record<string, string> = {
  visa: "Visa",
  mastercard: "Mastercard",
  amex: "American Express",
  discover: "Discover",
  diners: "Diners Club",
  jcb: "JCB",
  unionpay: "UnionPay",
  cartes_bancaires: "Cartes Bancaires",
  eftpos_au: "eftpos Australia",
} as const;

/**
 * Formats a Stripe card brand identifier for display.
 * Returns the brand display name if known, otherwise returns the brand as-is.
 *
 * @param brand - Card brand identifier from Stripe (e.g., "visa", "mastercard")
 * @returns Formatted display name (e.g., "Visa", "American Express")
 */
export function formatCardBrand(brand: string): string {
  return CARD_BRAND_DISPLAY_NAMES[brand.toLowerCase()] ?? brand;
}
